module.exports = "<div class=\"aside\" id=\"addBank\" content>\n    <ui-view></ui-view>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-add-bank/template.html
// module id = ./pages/xo-sidebar-add-bank/template.html
// module chunks = 1